export const css = {
    root: '_3Od9sEJl',
    ' _key': 'afcpe-theme/dojo/variants/dark'
};
export default css;
